export const convertBinaryToString = (value) => {
  if (value !== null) {
    return Boolean(value) && value !== '0' ? 'יש' : 'אין';
  }
}
